const getLanguage = state => state.language
const getEliteModal = state => state.eliteModal
export default {
  getLanguage,
  getEliteModal
}
